import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Paragraph } from '@/components/common/MarkUp';

import type { CaseStudy } from '@/sanity/sanity.types';

export type KeyFactsProps = CaseStudy['keyFacts'];

export const KeyFacts = (keyFacts: KeyFactsProps) => {
  if (!keyFacts || keyFacts.length === 0) return null;
  return (
    <Container>
      <OuterWrapper role="table">
        {Object.values(keyFacts).map((keyFact) => (
          <InnerWrapper key={keyFact._key} role="row">
            <TitleText size="label-sm" role="cell">
              {keyFact.title}
            </TitleText>
            <ContentText size="body-md" role="cell">
              {keyFact.description}
            </ContentText>
          </InnerWrapper>
        ))}
      </OuterWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: var(--space-block-md);
  gap: var(--space-block-md);

  border-top: 1px solid var(--border-warm-base);
`;

const OuterWrapper = styled.div`
  display: grid;
  gap: var(--space-block-md);

  ${screen.md} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ContentText = styled(Paragraph)`
  color: var(--text-galaxy);
`;

const TitleText = styled(Paragraph)`
  color: var(--text-warm-subtle);
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-block-sm);
`;
